export enum DeliveryType {
  Onetime = 'onetime',
  Longtime = 'longtime',
  Part = 'part',
}
